<header>
  <div class="header-content">
    <a class="wordmark" routerLink="/" aria-label="ATSIestudio, inicio" (click)="selectMenuItem()">
      <picture>
        <source media="(max-width: 30rem)" srcset="/images/atsi-estudio-symbol.svg" />
        <img src="/images/atsi-estudio-logo.svg" width="1200" height="360" alt="" />
      </picture>
    </a>

    <button
      #menuToggle
      class="menu-toggle"
      type="button"
      aria-controls="primary-navigation"
      [attr.aria-expanded]="isMenuOpen()"
      (click)="toggleMenu()"
    >
      <span class="menu-toggle-label">Menú</span>
      <span class="menu-toggle-icon" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>

    <nav id="primary-navigation" aria-label="Navegación principal" [class.is-open]="isMenuOpen()">
      <ul class="primary-menu">
        <li>
          <a
            routerLink="/"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="selectMenuItem()"
            >Inicio</a
          >
        </li>
        <li class="services-menu-item">
          <a
            routerLink="/servicios"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            (click)="selectMenuItem()"
            >Servicios</a
          >
          <ul class="services-submenu" aria-label="Servicios específicos">
            <li>
              <a routerLink="/servicios/desarrollo-web" (click)="selectMenuItem()"
                >Desarrollo web</a
              >
            </li>
            <li>
              <a routerLink="/servicios/desarrollo-personalizado" (click)="selectMenuItem()"
                >Desarrollo personalizado</a
              >
            </li>
            <li>
              <a routerLink="/servicios/mantenimiento" (click)="selectMenuItem()"
                >Mantenimiento web</a
              >
            </li>
            <li>
              <a routerLink="/servicios/hosting-y-dominios" (click)="selectMenuItem()"
                >Hosting y dominios</a
              >
            </li>
          </ul>
        </li>
        <li>
          <a
            routerLink="/como-trabajamos"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            (click)="selectMenuItem()"
            >Cómo trabajamos</a
          >
        </li>
        <li>
          <a
            routerLink="/proyectos"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            (click)="selectMenuItem()"
            >Proyectos</a
          >
        </li>
        <li>
          <a
            routerLink="/sobre-atsi-estudio"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            (click)="selectMenuItem()"
            >Sobre ATSIestudio</a
          >
        </li>
      </ul>

      <a
        class="contact-cta"
        routerLink="/contacto"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
        (click)="selectMenuItem()"
        >Cuéntanos tu proyecto</a
      >
    </nav>
  </div>
</header>
